import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "../utils/fetch.js";

const RequestSchema = z.object({
  id: z.number()
});

const ResponseSchema = z.void();

type Request = z.infer<typeof RequestSchema>;
type Response = z.infer<typeof ResponseSchema>;

export function useDeleteEntityFile(
  options?: UseMutationOptions<Response, Error, Request>
) {
  return useMutation({
    mutationFn: async (variables: Request) => {
      return api<Request, Response>({
        method: "DELETE",
        url: `/file/:id/delete`,
        requestSchema: RequestSchema,
        responseSchema: ResponseSchema,
        body: variables
      });
    },
    ...options
  });
}

export function useDeleteFile(
  options?: UseMutationOptions<Response, Error, Request>
) {
  return useMutation({
    mutationFn: async (variables: Request) => {
      return api<Request, Response>({
        method: "DELETE",
        url: `/file/unassigned/:id/delete`,
        requestSchema: RequestSchema,
        responseSchema: ResponseSchema,
        body: variables
      });
    },
    ...options
  });
}

// import { createMutation } from "../utils/queryFactories.js";
// import { z } from "zod";
// import { api } from "../utils/fetch.js";

// const RequestSchema = z.object({
//   id: z.number()
// });

// const ResponseSchema = z.object({});

// type Request = z.infer<typeof RequestSchema>;
// type Response = z.infer<typeof ResponseSchema>;

// export const useDeleteFile = createMutation<Response, Request, Error>({
//   mutationFn: async (variables) => {
//     return api<Request, Response>({
//       method: "DELETE",
//       url: `/file/unassigned/:id/delete`,
//       requestSchema: RequestSchema,
//       responseSchema: ResponseSchema,
//       body: variables
//     });
//   }
// });
